import styled, { css } from 'styled-components'
import { InputMaskProps } from '@elamajs/ui-kit'

export const Input = styled.input<InputMaskProps>`
  height: 50px;
  border: 1px solid #c2c7d6;
  border-radius: 5px;

  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 14px !important;
  line-height: 20px;
  color: #292e3d;

  + span[class^='InputMaskstyled__CustomPlaceholder'] {
    line-height: 5rem;
    height: 5rem;
  }

  &::placeholder {
    color: #a3abc2;
  }

  &:hover {
    border: 1px solid #c2c7d6;
    box-shadow: inset 0 0 0 1px #c2c7d6;
  }

  &:active,
  &:focus {
    border-color: #3a64f8;
    box-shadow: none;
  }

  ${({ borderless }) =>
    borderless &&
    css`
      border: none;
    `}

  ${({ hasError, errorMessage }) =>
    (hasError || errorMessage) &&
    css`
      border-color: #fa3848;
    `}
`
